import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';

export default function AgenciaViagensPage() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      {/* Navegação */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}>
        <div className="max-w-7xl mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <Link to="/" className="flex items-center">
              <img 
                src="https://static.readdy.ai/image/3c15764482320d2816a8cc3fe11ecba0/821bfe14b1fc609bf2a57dd541a10a42.png" 
                alt="FF TRAVEL - Agência de Viagens" 
                className="h-24 md:h-28"
              />
            </Link>
            
            <div className="hidden md:flex items-center space-x-8">
              <Link to="/" className="text-[#1e40af] hover:text-[#ff6b35] transition-colors font-medium">
                Início
              </Link>
              <Link to="/agencia-viagens" className="text-[#ff6b35] font-semibold">
                Agência de Viagens
              </Link>
              <Link to="/loja-servicos" className="text-[#1e40af] hover:text-[#ff6b35] transition-colors font-medium">
                Loja & Serviços
              </Link>
              <Link to="/sobre" className="text-[#1e40af] hover:text-[#ff6b35] transition-colors font-medium">
                Sobre
              </Link>
              <Link to="/contactos" className="text-[#1e40af] hover:text-[#ff6b35] transition-colors font-medium">
                Contactos
              </Link>
            </div>

            <a 
              href="https://wa.me/244936769113" 
              target="_blank" 
              rel="noopener noreferrer"
              className="hidden md:block bg-[#ff6b35] text-white px-6 py-3 rounded-full font-medium hover:bg-[#ff5722] transition-all shadow-md whitespace-nowrap cursor-pointer"
            >
              Pedir Cotação
            </a>
          </div>
        </div>
      </nav>

      {/* Hero */}
      <section className="relative pt-32 pb-20 bg-gradient-to-br from-[#1e40af] to-[#1e3a8a] overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-0 left-0 w-96 h-96 bg-white rounded-full blur-3xl animate-pulse"></div>
          <div className="absolute bottom-0 right-0 w-96 h-96 bg-[#ff6b35] rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1s' }}></div>
        </div>
        <div className="max-w-7xl mx-auto px-6 relative z-10">
          <div className="text-center text-white animate-fade-in">
            <h1 className="text-5xl md:text-6xl font-bold mb-6 animate-slide-up">
              Agência de Viagens Profissional
            </h1>
            <p className="text-xl text-white/90 max-w-3xl mx-auto animate-slide-up" style={{ animationDelay: '0.2s' }}>
              Soluções completas para suas viagens com atendimento personalizado e suporte em português
            </p>
          </div>
        </div>
      </section>

      {/* Passagens Aéreas */}
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <div>
              <div className="inline-block bg-[#ff6b35]/10 text-[#ff6b35] px-4 py-2 rounded-full text-sm font-semibold mb-6">
                Serviço Principal
              </div>
              <h2 className="text-4xl font-bold text-[#1e3a8a] mb-6">
                Passagens Aéreas e Reservas
              </h2>
              <p className="text-gray-600 text-lg leading-relaxed mb-6">
                &nbsp;Trabalhamos com as principais companhias aéreas para garantir preços competitivos e opções flexíveis.
              </p>
              <ul className="space-y-4 mb-8">
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-2xl text-[#ff6b35] flex-shrink-0"></i>
                  <span className="text-gray-700">Comparação de preços em tempo real</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-2xl text-[#ff6b35] flex-shrink-0"></i>
                  <span className="text-gray-700">Suporte completo antes, durante e após a viagem</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-2xl text-[#ff6b35] flex-shrink-0"></i>
                  <span className="text-gray-700">Opções de pagamento flexíveis</span>
                </li>
              </ul>
              <a 
                href="https://wa.me/244936769113" 
                target="_blank" 
                rel="noopener noreferrer"
                className="inline-block bg-[#ff6b35] text-white px-8 py-4 rounded-full font-semibold hover:bg-[#ff5722] transition-all shadow-lg whitespace-nowrap cursor-pointer"
              >
                Solicitar Cotação
              </a>
            </div>
            <div className="relative">
              <img 
                src="https://static.readdy.ai/image/3c15764482320d2816a8cc3fe11ecba0/7fe258a0fdd3bf571cadbf73fb54b410.jpeg"
                alt="Passagens Aéreas"
                className="rounded-3xl shadow-2xl w-full"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Pacotes Turísticos */}
      <section className="py-24 bg-gray-50">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <div className="order-2 lg:order-1">
              <img 
                src="https://static.readdy.ai/image/3c15764482320d2816a8cc3fe11ecba0/72eae0bc999c6da69f6fbb24be14261f.jpeg"
                alt="Pacotes Turísticos"
                className="rounded-3xl shadow-2xl w-full"
              />
            </div>
            <div className="order-1 lg:order-2">
              <div className="inline-block bg-[#ff6b35]/10 text-[#ff6b35] px-4 py-2 rounded-full text-sm font-semibold mb-6">
                Experiências Completas
              </div>
              <h2 className="text-4xl font-bold text-[#1e3a8a] mb-6">
                Pacotes Turísticos para Viagens Internacionais
              </h2>
              <p className="text-gray-600 text-lg leading-relaxed mb-6">
                &nbsp;Deixe tudo organizado conosco e aproveite sua viagem sem preocupações.
              </p>
              <ul className="space-y-4 mb-8">
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-2xl text-[#ff6b35] flex-shrink-0"></i>
                  <span className="text-gray-700">Hotéis selecionados e verificados</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-2xl text-[#ff6b35] flex-shrink-0"></i>
                  <span className="text-gray-700">Passeios e experiências exclusivas</span>
                </li>
              </ul>
              <a 
                href="https://wa.me/244936769113" 
                target="_blank" 
                rel="noopener noreferrer"
                className="inline-block bg-[#ff6b35] text-white px-8 py-4 rounded-full font-semibold hover:bg-[#ff5722] transition-all shadow-lg whitespace-nowrap cursor-pointer"
              >
                Ver Pacotes
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Vistos */}
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <div>
              <div className="inline-block bg-[#ff6b35]/10 text-[#ff6b35] px-4 py-2 rounded-full text-sm font-semibold mb-6">
                Assessoria Completa
              </div>
              <h2 className="text-4xl font-bold text-[#1e3a8a] mb-6">
                Processo de Obtenção de Vistos em Poucos Dias
              </h2>
              <p className="text-gray-600 text-lg leading-relaxed mb-6">
                Assessoria completa para obtenção de vistos para qualquer país. Cuidamos de toda a documentação e processo burocrático para você com rapidez e eficiência.
              </p>
              <ul className="space-y-4 mb-8">
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-2xl text-[#ff6b35] flex-shrink-0"></i>
                  <span className="text-gray-700">Vistos para Europa, América, Ásia e África</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-2xl text-[#ff6b35] flex-shrink-0"></i>
                  <span className="text-gray-700">Processo rápido em poucos dias</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-2xl text-[#ff6b35] flex-shrink-0"></i>
                  <span className="text-gray-700">Orientação sobre documentos necessários</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-2xl text-[#ff6b35] flex-shrink-0"></i>
                  <span className="text-gray-700">Agendamento de entrevistas consulares</span>
                </li>
              </ul>
              <a 
                href="https://wa.me/244936769113" 
                target="_blank" 
                rel="noopener noreferrer"
                className="inline-block bg-[#ff6b35] text-white px-8 py-4 rounded-full font-semibold hover:bg-[#ff5722] transition-all shadow-lg whitespace-nowrap cursor-pointer"
              >
                Consultar Visto
              </a>
            </div>
            <div className="relative">
              <img 
                src="https://static.readdy.ai/image/3c15764482320d2816a8cc3fe11ecba0/9972695858e8150a5f761ce5c9fa96db.jpeg"
                alt="Vistos"
                className="rounded-3xl shadow-2xl w-full"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Outros Serviços Grid */}
      <section className="py-24 bg-gray-50">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-[#1e3a8a] mb-4">
              Serviços Adicionais
            </h2>
            <p className="text-gray-600 text-lg">
              Tudo que você precisa para uma viagem completa e segura
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all">
              <div className="w-16 h-16 bg-[#1e40af]/10 rounded-2xl flex items-center justify-center mb-6">
                <i className="ri-hotel-line text-4xl text-[#1e40af]"></i>
              </div>
              <h3 className="text-2xl font-bold text-[#1e3a8a] mb-4">Reservas de Hotéis</h3>
              <p className="text-gray-600 mb-6 leading-relaxed">
                Hospedagem nos melhores hotéis com preços exclusivos e cancelamento flexível.
              </p>
              <a 
                href="https://wa.me/244936769113" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-[#ff6b35] font-semibold hover:underline cursor-pointer"
              >
                Reservar Hotel →
              </a>
            </div>

            <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all">
              <div className="w-16 h-16 bg-[#1e40af]/10 rounded-2xl flex items-center justify-center mb-6">
                <i className="ri-shield-check-line text-4xl text-[#1e40af]"></i>
              </div>
              <h3 className="text-2xl font-bold text-[#1e3a8a] mb-4">Seguro de Viagem</h3>
              <p className="text-gray-600 mb-6 leading-relaxed">
                Proteja sua viagem com seguros completos e assistência 24 horas.
              </p>
              <a 
                href="https://wa.me/244936769113" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-[#ff6b35] font-semibold hover:underline cursor-pointer"
              >
                Contratar Seguro →
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Final */}
      <section className="py-24 bg-gradient-to-br from-[#1e40af] to-[#1e3a8a]">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Pronto para Viajar?
          </h2>
          <p className="text-xl text-white/90 mb-10">
            Entre em contacto conosco e receba uma cotação personalizada para sua próxima viagem
          </p>
          <a 
            href="https://wa.me/244936769113" 
            target="_blank" 
            rel="noopener noreferrer"
            className="inline-block bg-[#ff6b35] text-white px-10 py-5 rounded-full font-bold text-lg hover:bg-[#ff5722] transition-all shadow-2xl whitespace-nowrap cursor-pointer"
          >
            Falar com Especialista
          </a>
        </div>
      </section>

      {/* Rodapé */}
      <footer className="bg-black text-white py-20">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
            <div>
              <img 
                src="https://static.readdy.ai/image/3c15764482320d2816a8cc3fe11ecba0/e349152b587c7809cba7381685cd68b4.png" 
                alt="FF TRAVEL - Agência de Viagens" 
                className="h-24 md:h-28 mb-8"
              />
              <p className="text-white/70 leading-relaxed mb-4">
                FF Prestação & Serviço, Lda
              </p>
              <p className="text-white/50 text-sm mb-6">
                NIF: 500714988
              </p>
              
              {/* Redes Sociais - DESTAQUE */}
              <div className="mb-6">
                <p className="text-white font-semibold text-sm mb-4 uppercase tracking-wider">
                  Siga-nos
                </p>
                <div className="flex gap-3">
                  <a 
                    href="https://www.instagram.com/ff_travel_angola/" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="w-12 h-12 bg-gradient-to-br from-purple-600 via-pink-600 to-orange-500 hover:scale-110 rounded-xl flex items-center justify-center transition-all shadow-lg cursor-pointer"
                    title="Instagram"
                  >
                    <i className="ri-instagram-line text-2xl text-white"></i>
                  </a>
                  <a 
                    href="https://www.facebook.com/share/1AVqwyfH7E/" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="w-12 h-12 bg-[#1877F2] hover:scale-110 rounded-xl flex items-center justify-center transition-all shadow-lg cursor-pointer"
                    title="Facebook"
                  >
                    <i className="ri-facebook-fill text-2xl text-white"></i>
                  </a>
                  <a 
                    href="https://www.linkedin.com/company/ff-travel" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="w-12 h-12 bg-[#0A66C2] hover:scale-110 rounded-xl flex items-center justify-center transition-all shadow-lg cursor-pointer"
                    title="LinkedIn"
                  >
                    <i className="ri-linkedin-fill text-2xl text-white"></i>
                  </a>
                </div>
              </div>
            </div>

            <div>
              <p className="text-white/50 text-xs uppercase tracking-wider mb-4">Contactos</p>
              <div className="space-y-3">
                <a href="tel:+244936769113" className="block text-white hover:text-[#ff6b35] transition-colors cursor-pointer">
                  +244 936 769 113
                </a>
                <a href="tel:+244927606910" className="block text-white hover:text-[#ff6b35] transition-colors cursor-pointer">
                  +244 927 606 910
                </a>
              </div>
            </div>

            <div>
              <p className="text-white/50 text-xs uppercase tracking-wider mb-4">Localização</p>
              <p className="text-white/70 leading-relaxed">
                Rua do Campo do Escoqueiro<br />
                De frente ao prédio do Cucu<br />
                Luanda, Angola
              </p>
            </div>

            <div>
              <p className="text-white/50 text-xs uppercase tracking-wider mb-4">Links Rápidos</p>
              <div className="space-y-3">
                <Link to="/" className="block text-white hover:text-[#ff6b35] transition-colors">Início</Link>
                <Link to="/agencia-viagens" className="block text-white hover:text-[#ff6b35] transition-colors">Agência de Viagens</Link>
                <Link to="/contactos" className="block text-white hover:text-[#ff6b35] transition-colors">Contactos</Link>
              </div>
            </div>
          </div>

          <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-white/50 text-sm">
              © 2025 FF TRAVEL. Todos os direitos reservados.
            </p>
            <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-white/50 hover:text-white transition-colors cursor-pointer text-sm">Powered by Readdy</a>
          </div>
        </div>
      </footer>

      {/* Botão WhatsApp Flutuante */}
      <a 
        href="https://wa.me/244936769113" 
        target="_blank" 
        rel="noopener noreferrer"
        className="fixed bottom-6 right-6 w-16 h-16 bg-[#ff6b35] rounded-full flex items-center justify-center text-white shadow-2xl hover:scale-110 transition-transform z-50 animate-pulse cursor-pointer"
        style={{ boxShadow: '0 8px 24px rgba(255, 107, 53, 0.4)' }}
      >
        <i className="ri-whatsapp-line text-3xl"></i>
      </a>
    </div>
  );
}
